@if (loading) {
  <p>{{ 'COMMON.LOADING' | translate }}</p>
} @else if (!rows.length) {
  <div class="patient-clinics__empty">{{ 'PATIENT_SPACE.CLINICS.EMPTY' | translate }}</div>
} @else {
  <section class="patient-clinics">
    <article class="patient-clinics__row" *ngFor="let row of rows">
      <div class="patient-clinics__identity">
        <strong>{{ row?.name }}</strong>
        <p>{{ row?.customer?.name }}</p>
        <small>{{ 'PATIENT_SPACE.CLINICS.HELP' | translate }}</small>
        @if (row?.address || row?.city || row?.province) {
          <div class="patient-clinics__contact-line">
            <i class="fas fa-map-marker-alt"></i>
            <span>
              {{ row?.address || '-' }}
              @if (row?.city || row?.province) {
                · {{ row?.city || '' }} {{ row?.province || '' }}
              }
            </span>
          </div>
        }
        @if (row?.phone) {
          <a class="patient-clinics__contact-line" [href]="'tel:' + row?.phone">
            <i class="fas fa-phone"></i>
            <span>{{ row?.phone }}</span>
          </a>
        }
        @if (row?.email) {
          <a class="patient-clinics__contact-line" [href]="'mailto:' + row?.email">
            <i class="fas fa-envelope"></i>
            <span>{{ row?.email }}</span>
          </a>
        }
      </div>

      <div class="patient-clinics__metrics">
        <span>
          {{ 'PATIENT_SPACE.CLINICS.TOTAL_APPOINTMENTS' | translate }}:
          <strong>{{ row?.metrics?.appointments_count || 0 }}</strong>
        </span>
        <span>
          {{ 'PATIENT_SPACE.CLINICS.LAST_APPOINTMENT' | translate }}:
          <strong>
            {{
              row?.metrics?.last_appointment_at
                ? (row?.metrics?.last_appointment_at | date: 'dd/MM/yyyy HH:mm')
                : ('PATIENT_SPACE.CLINICS.NO_DATE' | translate)
            }}
          </strong>
        </span>
        <span>
          {{ 'PATIENT_SPACE.CLINICS.NEXT_APPOINTMENT' | translate }}:
          <strong>
            {{
              row?.metrics?.next_appointment_at
                ? (row?.metrics?.next_appointment_at | date: 'dd/MM/yyyy HH:mm')
                : ('PATIENT_SPACE.CLINICS.NO_DATE' | translate)
            }}
          </strong>
        </span>
      </div>
    </article>
  </section>
}
